// extracted by mini-css-extract-plugin
export default {"dialog":"Dialog_dialog__BftPb","fade-in-and-slide-down":"Dialog_fade-in-and-slide-down__0pR1a"};